import { render, staticRenderFns } from "./recordNotesModal.vue?vue&type=template&id=d5af5bd2&scoped=true"
import script from "./recordNotesModal.vue?vue&type=script&lang=js"
export * from "./recordNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5af5bd2",
  null
  
)

export default component.exports